var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menubuilder__certification" }, [
    _c("h3", [_vm._v("Certification")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "Would you like the coffee accreditation logos and descriptions to show on you menu?"
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menubuilder__radiowrapper" }, [
      _c("label", { attrs: { for: "certificate_yes" } }, [
        _vm._v("\n      Yes\n      "),
        _c("br"),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.hasCertifications.value,
              expression: "hasCertifications.value",
            },
          ],
          attrs: {
            type: "radio",
            value: "true",
            id: "certificate_yes",
            name: "certificate_yes",
          },
          domProps: { checked: _vm._q(_vm.hasCertifications.value, "true") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.hasCertifications, "value", "true")
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", { attrs: { for: "certificate_no" } }, [
        _vm._v("\n      No\n      "),
        _c("br"),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.hasCertifications.value,
              expression: "hasCertifications.value",
            },
          ],
          attrs: {
            type: "radio",
            value: "false",
            id: "certificate_no",
            name: "certificate_no",
          },
          domProps: { checked: _vm._q(_vm.hasCertifications.value, "false") },
          on: {
            change: function ($event) {
              return _vm.$set(_vm.hasCertifications, "value", "false")
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menubuilder__images" }, [
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: _vm.organicLogo.url } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: _vm.fairtradeLogo.url } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: _vm.rainforestLogo.url } }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/MenuBuilder/CertificationSelector.vue